import React from "react";
import { Tooltip } from "antd";
import Icon from "@mdi/react";
import { mdiCheck, mdiInformationOutline } from "@mdi/js";
import { BRAND_FILTER_LOGOS, useGdBrands, findGdBrandByCode } from "../brand-logos";

export interface BrandOption {
  value: string;
  label: string;
}

export type BrandCardVariant = "stacked" | "row" | "row-radio";

interface Props {
  brands: BrandOption[];
  selected: string[];
  variant?: BrandCardVariant;
  columns?: number;
  onToggle: (value: string) => void;
}

export default function BrandCards({
  brands,
  selected,
  variant = "stacked",
  columns = 2,
  onToggle,
}: Props) {
  const { brands: gdBrands } = useGdBrands();

  return (
    <div
      className={`v2-filters__brands v2-filters__brands--${variant}`}
      style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
    >
      {brands.map((brand) => {
        const checked = selected.includes(brand.value);
        const logo = BRAND_FILTER_LOGOS[brand.value];
        const description = findGdBrandByCode(gdBrands, brand.value)?.description;

        return (
          <button
            key={brand.value}
            type="button"
            aria-pressed={checked}
            className={`v2-brand-card ${checked ? "is-active" : ""}`}
            onClick={() => onToggle(brand.value)}
          >
            {variant !== "row" && (
              <span className="v2-brand-card__check" aria-hidden="true">
                {checked && <Icon path={mdiCheck} size="14px" />}
              </span>
            )}
            <span className="v2-brand-card__logo">{logo && <img src={logo} alt="" />}</span>
            <span className="v2-brand-card__name">
              {brand.label}
              {description ? (
                <Tooltip title={description} color="#484954">
                  <Icon path={mdiInformationOutline} size="16px" />
                </Tooltip>
              ) : (
                <Icon path={mdiInformationOutline} size="16px" />
              )}
            </span>
          </button>
        );
      })}
    </div>
  );
}
